module.exports = __webpack_public_path__ + "img/loading.14a63c8a.gif";